<template>
  <v-row
    style="
      padding: 0vw 7vw;
      height: 64px;
      position: sticky;
      border-bottom: 9px solid #ff7c45;
      border-top: 1px dashed rgba(0, 133, 124, 0.5);
    "
    align="center"
  >
    <v-layout justify-space-between style="bottom: 10px">
      <!--      <div class="m-footer__copyright">Email: info@zeda.ai <tab /></div>-->
      <div class="mt-1" style="font-size: 16px" :style="paragraphOneFont">
        &copy; 2022 zeda.ai. All rights reserved.
      </div>
      <div>
        <div class="tab" />
        <router-link
          style="font-size: 16px; color: #000000; padding-right: 6vw"
          :style="paragraphOneFont"
          to="/privacy-policy"
          >Privacy Policy</router-link
        >
        <router-link
          style="font-size: 16px; color: #000000"
          to="/"
          :style="paragraphOneFont"
          >Terms & Conditions</router-link
        >
      </div>
    </v-layout>
  </v-row>
</template>

<script>
export default {
  name: "AdFooter",
  computed: {
    paragraphOneFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size: 12px; line-height: 14px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Extra small screens (less than 600px)
        case "sm":
          return "font-size: 14px; line-height: 20px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Small screens (600px and up)
        case "md":
          return "font-size: 14px; line-height: 20px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Medium screens (960px and up)
        case "lg":
          return "font-size: 20px; line-height: 28px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Large screens (1264px and up)
        case "xl":
          return "font-size: 20px; line-height: 28px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Extra large screens (1904px and up)
        default:
          return "font-size: 20px; line-height: 28px; font-weight: 400; font-family: 'Arial';  color: #475560";
      }
    },
  },
};
</script>

<style>
.m-footer {
  flex-grow: 0;
}
.m-footer__links__link {
  color: rgba(255, 255, 255, 0.8);
  border-right: 1px solid #fff;
  padding: 0px 20px 0 20px;
}

.tab {
  display: inline-block;
  margin-left: 10px;
}
.new-fixed-footer {
  display: flex;
  flex-direction: column;
  height: 100%;
  color: red;
}
</style>
